import { render } from "./index.vue?vue&type=template&id=74382627&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=74382627&scoped=true&lang=scss"
import "./index.vue?vue&type=style&index=1&id=74382627&lang=scss"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-01d4bca84f43bee68-1/assemble-sports/aucklandrugbyleague-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74382627"]])

export default __exports__